export default __webpack_public_path__ + "static/media/hp.d8b81129.svg";